import { Document } from '@react-pdf/renderer';
import React from 'react';
import { CompanyFullInfo } from 'src/pages/MainPage/_BLL/types';
import { Page1 } from './Page1';
import { Page2 } from './Page2';
import { PageDecoratorPDF } from './PageDecoratorPDF';

export const CertificateTemplate: React.FC<CompanyFullInfo> = (props) => {
	const {
		id, //
		name,
		dateOfIssue,
		expirationDate,
		properties,
	} = props;

	// * Render
	return (
		<Document>
			<PageDecoratorPDF
				dateOfIssue={dateOfIssue}
				expirationDate={expirationDate}
			>
				<Page1
					name={name}
					properties={properties}
				/>
			</PageDecoratorPDF>

			<PageDecoratorPDF
				dateOfIssue={dateOfIssue}
				expirationDate={expirationDate}
			>
				<Page2 />
			</PageDecoratorPDF>
		</Document>
	);
};
